import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID, ErrorHandler } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CommonModule, LocationStrategy, PathLocationStrategy, registerLocaleData } from '@angular/common';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { LocalizationService } from "app/shared/localization/localization.service";
import { SharedModule, HttpLoaderFactory } from './shared/shared.module';
import { HttpInterceptorProviders } from './shared/interceptors';
import { MessageService } from 'primeng/api';
import { StoreModule } from '@ngrx/store';
import { reducers } from './app-state.index';
import localeHe from '@angular/common/locales/he';
import { PublicModule } from 'app/public/public.module';
import { CoreModule } from './core/core.module';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from 'environments/environment';
import { ErrorHandling } from './shared/handlers/error-handling.handler';
import { LoginModule } from './login/login.module';
import { TooltipModule } from 'primeng/tooltip';
import { CookieBannerComponent } from './public/components/cookie-banner/cookie-banner.component';




registerLocaleData(localeHe);

@NgModule({
  declarations: [
    AppComponent,
     CookieBannerComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CommonModule,
    PublicModule,
    CoreModule,
    HttpClientModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    SharedModule.forRootOrChild(),
    LoginModule,
    StoreModule.forRoot(reducers),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production, // Restrict extension to log-only mode
      autoPause: true, // Pauses recording actions and state changes when the extension window is not open
    }),
    TooltipModule
  ],
  providers: [
    HttpInterceptorProviders,
    LocalizationService,
    MessageService,
    { provide: ErrorHandler, useClass: ErrorHandling },
    { provide: LOCALE_ID, useValue: 'he' },
    { provide: LocationStrategy, useClass: PathLocationStrategy } ,    //PathLocationStrategy avoid # in url
    
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
